<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc-title"><a id="pageiv" title="iv"></a><a id="pagev" title="v">Table of Contents</a></h1><a id="pagev" title="v">
</a><h2 class="toc-fm"><a id="pagev" title="v"></a><a href="#/xhtml/Author#Author">Author’s Note: Sources and Methods</a></h2>
<h2 class="toc-fm"><a href="#/xhtml/Acknowledgments#Acknowledgments">Acknowledgments</a></h2>
<h2 class="toc-fm"><a href="#/xhtml/Introduction#Introduction">Introduction</a></h2>
<h2 class="toc-ch"><a href="#/xhtml/Chapter01#Chapter01">Part 1: United States Presidential Administrations</a></h2>
<h2 class="toc-ch"><span href="#/xhtml/Chapter02#Chapter02" title="Link target outside of Sample">Part 2: United States Congress</span></h2>
<h2 class="toc-ch"><span href="#/xhtml/Chapter03#Chapter03" title="Link target outside of Sample">Part 3: United States Military</span></h2>
<h2 class="toc-ch"><span href="#/xhtml/Chapter04#Chapter04" title="Link target outside of Sample">Part 4: Governors</span></h2>
<h2 class="toc-ch"><span href="#/xhtml/Chapter05#Chapter05" title="Link target outside of Sample">Part 5: City Founders and Mayors</span></h2>
<h2 class="toc-ch"><span href="#/xhtml/Chapter06#Chapter06" title="Link target outside of Sample">Part 6: Officers of Professional Societies</span></h2>
<h2 class="toc-ch"><span href="#/xhtml/Chapter07#Chapter07" title="Link target outside of Sample">Part 7: Higher Education</span></h2>
<h2 class="toc-ch"><span href="#/xhtml/Chapter08#Chapter08" title="Link target outside of Sample">Part 8: Native Americans, Philanthropists, Industrialists, and Others</span></h2>
<h2 class="toc-ch"><span href="#/xhtml/Appendix#Appendix" title="Link target outside of Sample">Appendix</span></h2>
<h2 class="toc-ch"><span href="#/xhtml/Bibliography#Bibliography" title="Link target outside of Sample">Bibliography</span></h2>
<h2 class="toc-ch"><span href="#/xhtml/Bonus#Bounus" title="Link target outside of Sample">BONUS EXCERPT:</span></h2>
<h2 class="toc-ch0"><span href="#/xhtml/Bonus" title="Link target outside of Sample"><em class="italic">From Arlington to Appomattox: Robert E. Lee Day by Day, 1861-1865,</em> by Charles R. Knight</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?293d8a5b